import { useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Link, Paper, Typography, useTheme
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { DataGrid, GridColDef, GridEventListener } from "@mui/x-data-grid";

import { FranquiaService, IDetalheFranquia, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { Loading } from "../../shered/components/loading/Loading";
import { IDadosPodcasts, IFiltosBlog, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import dayjs from "dayjs";
import { ptBR } from '@mui/x-data-grid/locales';

export const ListagemDeBlogs: React.FC = () => {
    const theme = useTheme();
    const { formRef, save } = useVForm();
    const { themeName } = useAppThemeContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, logout } = useAuthContext();
    const [removeLoading, setRemoveLoading] = useState(false);
    const [rowsPodcasts, setRowsPodcasts] = useState<IDadosPodcasts[]>([]);
    const [lstFranquias, setLstFranquias] = useState<ILstDrop[]>([]);    
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const columnsJogadores: GridColDef[] = [
        {
            field: 'codigo',
            headerName: 'ID',
            width: 90,
            //flex: 1,
            headerClassName: 'super-app-theme--header',
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'url',
            headerName: 'URL',
            description: 'Nome do Jogador da Franquia escolhido',
            sortable: false,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => <Link href={params.value} underline="none" target='blank'>{params.value}  </Link>,
            //valueGetter: (params: GridValueGetterParams) =>`${params.row.nome_Jogador_Escolhido || ''}`,
        },
        {
            field: 'dtCriacao',
            headerName: 'DATA',
            width: 190,
            headerClassName: 'super-app-theme--header',
            valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY HH:mm'),
            headerAlign: "center",
            align: "center"
        }
    ];



    useEffect(() => {

        setIsLoading(true);
        const fetchData = async () => {
            setIsLoading(false);
            let dadosFiltro: IFiltosBlog = {
                codigo_Parceiro: 2
            }
            UtilidadeService.getPodCasts(dadosFiltro)
                .then(result => {
                    const list = result.dado.sort((a, b) => Number(new Date(b.codigo)) - Number(new Date(a.codigo))).filter(e => { return e !== null });

                    setRowsPodcasts(list);
                }).catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão Expirada! 1",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response.data.mensagem !== undefined) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados dos jodadores! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });
            FranquiaService.getByIdLiga(Number(codigoLiga)).then(result => {
                let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
                setLstFranquias(lstFranquia);
            }).catch((errors) => {
                setRemoveLoading(true);
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Sessão Expirada! 2",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response.data.mensagem !== undefined) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                }
                else {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da franquia! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                }
            });
        }
        fetchData();
        setRemoveLoading(true);
    }, []);

    const handleSave = async (dados: IDetalheFranquia) => {
        setIsLoading(true);
        setIsLoading(false);
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    };

    const MyCustomNoRowsOverlay = () => (
        <Grid container size={{ xs: 12, sm: 12 }} paddingTop={2} display="flex" justifyContent="center" textAlign="center"  >
            {!removeLoading ? <Loading />
                : <Typography>Sem Registro(s)</Typography>
            }
        </Grid>
    );

    // const handleRedirect: GridEventListener<'rowClick'> = (params) => {
    //     let crypt = UtilidadeService.crypt(`J|${params.row.codigo.toString()}|0`);
    //     navigate(`/liga/jogadores/detalhe/${crypt}`);
    // }

    return (
        <LayoutBaseDePagina
            titulo="Podcasts Parceiro"
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate("/dashboard")}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={3}>
                        <Grid container size={{ xs: 12, sm: 12 }}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6">Lista de Podcasts</Typography>
                                <hr />
                            </Grid>
                            <Grid margin={1} spacing={1} paddingBottom={1}>
                                {!removeLoading && <Loading />}
                            </Grid>
                            <Box sx={{
                                height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                '& .super-app-theme--header': {
                                    backgroundColor: theme.palette.common.black,
                                    color: theme.palette.common.white
                                },
                                '& .super-app.negative': {
                                    color: 'red',
                                    fontWeight: 'bold'
                                },
                                '& .super-app.positive': {
                                     color: themeName === "light" ? "black" : "auto",
                                },
                            }}>
                                <DataGrid
                                    getRowId={(rows) => rows.codigo}
                                    rows={rowsPodcasts !== undefined ? rowsPodcasts : []}
                                    columns={columnsJogadores}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 24,
                                            },
                                        },
                                    }}
                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                    pageSizeOptions={[24, 50, 100]}
                                    autoHeight
                                    slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}

                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
}